// extracted by mini-css-extract-plugin
export default {"pagina":"Documentacoes_pagina__lTGSm"};